import { motion } from 'motion/react';
import { ArrowUpRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { MagneticButton } from './MagneticButton';
import { TextScramble } from './TextScramble';
import { ScrollShadow } from './ScrollShadow';

export function Footer() {
  const navigate = useNavigate();
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      navigate(path, { state: { fromMobile: false, fromNav: true } });
    }, 100);
  };

  return (
    <section className="relative z-10 py-16 md:py-24 px-6 bg-black text-white text-center">
      <div className="max-w-6xl mx-auto flex flex-col justify-between min-h-[40vh]">
        <div className="space-y-12 md:space-y-16 mt-8">
          <ScrollShadow>
            <div className="flex flex-col items-center justify-center gap-12 md:gap-16">
              <h2 className="text-[31px] md:text-[52px] lg:text-[64px] font-bold tracking-tighter uppercase font-display">Contact</h2>
              <div className="mb-8 flex flex-col items-center gap-12 md:gap-16">
                <p className="opacity-80 text-lg md:text-xl font-sans">
                  Always eager to collaborate and connect.
                </p>
                <MagneticButton>
                  <a 
                    href="/contact"
                    onClick={(e) => handleLinkClick(e, '/contact')} 
                    className="group flex items-center gap-2 md:gap-3 border-2 border-white/20 hover:border-transparent pl-5 pr-4 py-3 md:pl-8 md:pr-6 md:py-4 hover:bg-white hover:text-black transition-all duration-300 hover-target font-mono text-[10px] md:text-[12px] uppercase tracking-[0.2em] font-bold relative overflow-hidden"
                  >
                    <span className="relative z-10"><TextScramble text="Get In Touch" /></span> <ArrowUpRight className="text-[#9af104] group-hover:text-black opacity-100 transition-opacity relative z-10 w-3.5 h-3.5 md:w-4 md:h-4" />
                  </a>
                </MagneticButton>
              </div>
            </div>
          </ScrollShadow>
        </div>
      </div>
    </section>
  );
}
